module.exports = __webpack_public_path__ + "img/bfd9fb3.png";